import { User, Briefcase, LineChart, Banknote } from "lucide-react";
import React from "react";

const WhoWeHelp = () => {
  const categories = [
    {
      icon: <User />,
      title: "Salaried Professionals",
      description:
        "Professionals looking to start SIPs, plan long-term goals, and invest consistently despite market volatility.",
    },
    {
      icon: <Briefcase />,
      title: "Self-Employed & Business Owners",
      description:
        "Individuals seeking structured investing, tax-efficient planning, and stability beyond business income.",
    },
    {
      icon: <LineChart />,
      title: "Serious Long-Term Investors",
      description:
        "Investors who value discipline, patience, and a process-driven approach over tips, hype, or short-term market moves.",
    },
    {
      icon: <Banknote />,
      title: "Families Planning for Life Goals",
      description:
        "Families investing for children’s education, home planning, and retirement with a long-term perspective.",
    },
  ];

  return (
    <div className="border border-black-dark-200 w-full rounded-3xl py-24">
      <section className="max-w-screen-xl mx-auto px-6 md:px-10">
        {/* Heading */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-6xl xl:text-7xl font-bold text-white">
            Who We <span className="text-primary1">Work With</span>
          </h2>
          <p className="mt-6 text-gray-300 text-base sm:text-lg">
            We primarily work with salaried professionals, self-employed
            individuals, and families who want clarity, discipline, and
            long-term financial direction not speculation.
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {categories.map((category, index) => (
            <div
              key={index}
              className="bg-black-dark-400 p-6 sm:p-8 rounded-2xl shadow-md hover:shadow-xl transition"
            >
              <div className="flex items-start gap-5">
                {/* Icon Wrapper */}
                <div className="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16">
                  {React.cloneElement(category.icon, {
                    className: "w-8 h-8 sm:w-9 sm:h-9 text-primary1",
                  })}
                </div>

                {/* Content */}
                <div>
                  <h3 className="text-lg sm:text-xl font-semibold text-white">
                    {category.title}
                  </h3>
                  <p className="text-gray-400 text-sm sm:text-base mt-2">
                    {category.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default WhoWeHelp;
